<template>
  <icon name="spin" :class="paused ? '_paused' : ''"></icon>
</template>

<script>
import icon from './icon'

export default {
  props: {
    paused: Boolean
  },

  components: {
    icon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/spin.vue